import $ from "jquery";
import "jquery-mask-plugin";

function init() {
    initDatePicker();
    initDateTimePicker();
    initTimePicker();
}

function initDatePicker() {
    $(".datepicker").mask("00/00/0000", { placeholder: "mm/dd/yyyy" }).flatpickr({
        allowInput: true,
        dateFormat: "m/d/Y"
    });
}

function initDateTimePicker() {
    $(".datetimepicker").flatpickr({
        dateFormat: "m/d/Y h:i K",
        enableTime: true,
        static: true
    });
}

function initTimePicker() {
    $(".timepicker").flatpickr({
        dateFormat: "h:i K",
        enableTime: true,
        noCalendar: true,
        static: true
    });
}

function toShortDate(date) {
    return (date.getMonth() + 1) +
        "/" + date.getDate() +
        "/" + date.getFullYear();
}

export const dateFormatter = {
    init: init,
    initDatePicker: initDatePicker,
    initDateTimePicker: initDateTimePicker,
    initTimePicker: initTimePicker,
    toShortDate: toShortDate
};